<template>
  <div class="mod-step1">
    <p>尊敬的{{ name }}旅客，<br/>您正在使用实名认证功能{{ title }}，请选择身份认证方式：</p>
    <div class="action">
      <a-button type="primary" size="large" v-if="hasAuth('UNION_PAY_AUTH')" @click="onNext('UNION_PAY_AUTH')">银联认证</a-button>
      <a-button type="primary" size="large" v-if="hasAuth('WX_FACE_AUTH')" @click="onNext('WX_FACE_AUTH')">人脸认证</a-button>
      <a-button type="primary" size="large" v-if="hasAuth('WX_PAY_AUTH')" @click="onNext('WX_PAY_AUTH')">微信认证</a-button>
    </div>
    <div class="other" v-if="showOtherAuthBtn" @click="onNext('ARTIFICIAL_AUTH')"><span>儿童、港澳台及外籍旅客</span>实名认证 >></div>
  </div>
</template>

<script>
// import { findIndex } from 'lodash'
import moment from 'moment'

export default {
  props: {
    ffpUserInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    userInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    name: String,
    title: String,
    type: String,
    authTypeMenus: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      showOtherAuthBtn: false
    }
  },
  // created () {
  //   if (['JD'].includes(this.airline)) return
  //   if (this.userInfo.userCerts && this.userInfo.userCerts.length) {
  //     const niIndex = findIndex(this.userInfo.userCerts, ['certType', 5])

  //     if (niIndex === -1) {
  //       this.showOtherAuthBtn = true
  //     } else {
  //       if (this.isChd(this.userInfo.userCerts[niIndex].certNo)) {
  //         this.showOtherAuthBtn = true
  //       }
  //     }
  //   }
  // },
  methods: {
    hasAuth (authType) {
      const { authTypeMenus = [], type } = this
      const authTypeMaps = authTypeMenus.filter(item => item.enable)?.map(item => item.code) || []
      if (type === 'auth') {
        return authTypeMaps.includes(authType)
      } else {
        return authTypeMaps.includes(authType) && authType === 'UNION_PAY_AUTH'
      }
    },
    onNext (type) {
      if (type === 'other') {
        const { chiSurname, chiName, engName, engSurname } = this.userInfo

        if (!chiSurname && !chiName && !engName && !engSurname) {
          this.$error({
            content: '请先完善个人资料再申请此类型实名认证',
            centered: true,
            onOk: () => {
              this.$router.push({ path: '/infomation' })
            }
          })

          return
        }
      }

      this.$emit('next', type)
    },
    onGo () {},
    isChd (idCard) {
      const birthFormat = moment(this.fillBirthday(idCard, true), 'YYYY-MM-DD')
      const currentFormat = moment(new Date(), 'YYYY-MM-DD')
      const diffYears = currentFormat.diff(birthFormat, 'years')
      return diffYears >= 2 && diffYears <= 12
    },
    /**
     * 根据身份证号获取生日
     */
    fillBirthday (idCard, isReturn = false) {
      let birth = ''
      if (idCard.length === 15) {
        birth = idCard.slice(6, 12)
        birth = '19' + birth
      } else if (idCard.length === 18) {
        birth = idCard.slice(6, 14)
      }
      const birthday = birth.slice(0, 4) + '-' + birth.slice(4, 6) + '-' + birth.slice(6, 8)
      const birthFormat = moment(birthday, 'YYYY-MM-DD')
      if (!isReturn) {
        this.form.setFieldsValue({
          birthday: birthFormat
        })
      } else {
        return birthday
      }
    }
  }
}
</script>
